// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
define(['react', 'react-i18next'], (React, {Translation})=>{
const E = {};

const HELP_DOCS = 'https://docs.brightdata.com';
const HELP_DOCS_PROXY = `${HELP_DOCS}/proxy-networks`;
const HELP_DOCS_AUTOMATION = `${HELP_DOCS}/scraping-automation`;
const HELP_BASE = 'https://help.brightdata.com';

E.LINK_DOCS = HELP_DOCS;
E.LINK_API_DOCS = `${HELP_DOCS}/api-reference`;
E.LINK_ALL_TICKETS = `${HELP_BASE}/hc/en-us/requests`;
E.LINK_SUPPORT = `${HELP_BASE}/hc/en-us/requests/new`;
E.LINK_FAQ = `${HELP_DOCS}/general/faqs`;
E.LINK_CP_LPM = 'https://brightdata.com/cp/zones/lpm';
E.LINK_CP_BEXT = 'https://brightdata.com/cp/zones/bext';
E.LINK_SERP_API = 'https://brightdata.com/cp/serp_api';
E.LINK_QUICK_START_GUIDES = '#';
E.LINK_PROXY_NETWORK_TYPES = HELP_DOCS_PROXY;
E.LINK_FAQ_PROXY = E.LINK_FAQ+'/proxy-networks';
E.LINK_PROXY_EXAMPLES = 'https://brightdata.com/cp/zones/proxy_examples';
E.LINK_FAQ_SMART_RESI = HELP_DOCS_PROXY+'/residential/network-access';
E.LINK_ZENDESK_REQUESTS = 'https://brightdata.zendesk.com/hc/en-us/requests';
E.LINK_ZENDESK_NEW = 'https://brightdata.zendesk.com/hc/en-us/requests/new';
E.LINK_FAIR_USE = HELP_DOCS+'/general/usage-monitoring/fair_use_allowance';

E.HELP_LINK = {
    NETWORK_PROXIES: HELP_DOCS_PROXY+'/introduction',
    DC: `${HELP_DOCS_PROXY}/data-center/introduction`,
    ISP: `${HELP_DOCS_PROXY}/isp/introduction`,
    RESIDENTIAL: `${HELP_DOCS_PROXY}/residential/introduction`,
    LONG_SESSION_PEERS: HELP_DOCS_PROXY+
        '/residential/configure-your-proxy#long-session-peers',
    CACHE_PROXY: HELP_DOCS_PROXY+
        '/residential/configure-your-proxy#enable-cache-proxy',
    MOBILE: `${HELP_DOCS_PROXY}/mobile/introduction`,
    WEB_UNLOCKER: `${HELP_DOCS_AUTOMATION}/web-unlocker/introduction`,
    SERP_API: `${HELP_DOCS_AUTOMATION}/serp-api/introduction`,
    SCRAPING_BROWSER: `${HELP_DOCS_AUTOMATION}/scraping-browser/introduction`,
    PROXY_MANAGER: `${HELP_DOCS_PROXY}/proxy-manager/introduction`,
    BEXT: `${HELP_DOCS_AUTOMATION}/browser-extension/introduction`,
    SETTING: `${HELP_DOCS}/general/billing-and-pricing/account-related`,
    DASHBOARD: HELP_DOCS_PROXY,
    BILLING: `${HELP_DOCS}/general/billing-and-pricing/Billing`,
    SCRAPING_BROWSER_GETTING_STARTED: HELP_DOCS_AUTOMATION+
        '/scraping-browser/introduction',
    SCRAPING_BROWSER_BANDWIDTH: HELP_DOCS+
        '/scraping-automation/scraping-browser/faqs#what-are-some-tips-for-reducing-bandwidth-while-scraping',
    SCRAPING_BROWSER_CAPTCHA: `${HELP_DOCS}/faqs/scraping-browser`,
    SCRAPING_BROWSER_ALL_DOC: HELP_DOCS_AUTOMATION+
        '/scraping-browser/introduction',
    SCRAPING_BROWSER_PYTHON: HELP_DOCS_AUTOMATION+'/scraping-browser/quickstart',
    SCRAPING_BROWSER_NODEJS: HELP_DOCS_AUTOMATION+'/scraping-browser/introduction',
    DCA_WORKER_TYPE: HELP_DOCS_AUTOMATION+
        '/web-scraper-ide/basics-of-web-scraping#browser-worker-vs-code-worker',
    DCA_IDE: E.LINK_API_DOCS+'/web-scraper-ide-api/Getting_started_wtih_the_API',
    DCA_IDE_BEST_PRACTICES: `${HELP_DOCS_AUTOMATION}/web-scraper-ide/best-practices`,
    DCA_IDE_COMPLETE_EXAMPLES: `${HELP_DOCS_AUTOMATION}/web-scraper-ide/complete-examples`,
    DCA_HOW_TO: E.LINK_FAQ_PROXY,
    DATASETS: `${HELP_DOCS_AUTOMATION}/datasets`,
    DC_ISP_IP_TYPE: HELP_DOCS_PROXY+
        '/data-center/configure-your-proxy#ip-type',
    RESI_MOBILE_IP_TYPE: HELP_DOCS_PROXY+
        '/residential/configure-your-proxy#ip-type',
    GEOLOCATION_TARGETING: HELP_DOCS_PROXY+
        '/residential/configure-your-proxy#geolocation-targeting',
    DC_GEOLOCATION_TARGETING: HELP_DOCS_PROXY+
        '/data-center/configure-your-proxy#geolocation-targeting',
    ISP_GEOLOCATION_TARGETING: HELP_DOCS_PROXY+
        '/isp/configure-your-proxy#geolocation-targeting',
    MOBILE_GEOLOCATION_TARGETING: HELP_DOCS_PROXY+
        '/mobile/configure-your-proxy#geolocation-targeting',
    RESI_MOBILE_NUM_DOMAINS: HELP_DOCS_PROXY+
        '/residential/configure-your-proxy#domains',
    PREMIUM_DOMAINS_UB: HELP_DOCS_AUTOMATION+
        '/web-unlocker/features#web-unlocker-premium-domains',
    PREMIUM_DOMAINS_SBR: HELP_DOCS_AUTOMATION+
        '/scraping-browser/features/premium-domains',
    TARGET_DOMAINS: HELP_DOCS_AUTOMATION+
        '/web-unlocker/features#web-unlocker-target-domain-tiers',
    SERP_ASYNC_REQS: `${HELP_DOCS_AUTOMATION}/serp-api/asynchronous-requests`,
    UB_CUSTOM_HEADERS_COOKIES: HELP_DOCS_AUTOMATION+
        '/web-unlocker/configuration#custom-headers-and-cookies',
    PORTS: `${E.LINK_FAQ_PROXY}#how-to-see-supported-ports-and-protocols`,
    UPTIME: HELP_DOCS_PROXY+
        '/data-center/configure-your-proxy#100-uptime',
    BANDWIDTH: HELP_DOCS_PROXY+
        '/isp/configure-your-proxy#unlimited-bandwidth',
    CERT_INSTALL: E.LINK_FAQ_PROXY,
    SCRAPING_SHIELD: HELP_DOCS_AUTOMATION+'/bright-shield/scraping-shield',
    ASSET_SHIELD: HELP_DOCS_AUTOMATION+'/bright-shield/asset-shield',
    UNLIM_BW_PKG: 'XXX: insert me',
    SSL_IGNORE: `${HELP_DOCS}/general/account/ignore-ssl-errors`,
    AUTO_UB: HELP_DOCS_PROXY+
        '/residential/configure-your-proxy#enable-automated-unlocking',
    ENABLE_BROWSERS: HELP_DOCS_PROXY+'/residential/configure-your-proxy'+
        '#enable-javascript-rendering-with-hosted-browsers',
    PLAYGROUND_MODE: `${E.LINK_FAQ}#what-is-playground-mode`,
    WHITELIST_IPS: `${HELP_DOCS_PROXY}/faqs#how-to-whitelist-blacklist`+
        `-ips-and-domains`,
    CONFIG_OPTIONS: `${HELP_DOCS_PROXY}/config-options`,
    CAPTCHA_SOLVER: `${HELP_DOCS_AUTOMATION}/web-unlocker/features#`+
        `disable-captcha-solving`,
    GOOGLE_ADS: `${HELP_DOCS_AUTOMATION}/serp-api/parsing-search-results#ads`,
    DEFAULT_COUNTRY: HELP_DOCS_PROXY+
        '/faqs#how-can-i-set-default-countries-for-zones-with-fixed-ip-pools',
    MANUAL_EXPECT_EL: `${HELP_DOCS_AUTOMATION}/web-unlocker/features#`+
        `manual-expect-elements`,
    API_DEFAULT_COUNTRY: `${E.LINK_API_DOCS}/proxy/geolocation-targeting`,
    RELEASE_NOTES: `${HELP_DOCS}/general/release-notes`,
    ORDER_MISSING_IPS: HELP_DOCS_PROXY+
        '/data-center/faqs#can-i-order-missing-proxies-for-datacenter-and-isp',
};
E.VIDEOS = {
    SCRAPING_BROWSER_INTRO: '/static/scraping_browser_get_started.mp4',
    WELCOME_TO_PROXIES: {
        src: '/static/welcome_to_proxies.mp4',
        title: 'Get Started With Proxies',
        embeded: 'https://www.youtube.com/embed/VuIl5J2nR3U',
    },
    WELCOME_TO_DATASETS: {
        type: 'dca',
        src: '/static/welcome_to_datasets.mp4',
        title: 'Get Started With Datasets',
        embeded: 'https://www.youtube.com/embed/sUDROEVLqEk',
    },
    WELCOME_TO_BD: {
        src: '/static/welcome_to_bd.mp4',
        embeded: 'https://www.youtube.com/embed/AGaiVApKfmc',
        no_rel: 1,
        autoplay: 1,
        title: 'Welcome To Bright Data',
    },
    DATASET_MARKETPLACE: {
        type: 'dca',
        src: '/static/dataset_marketplace.mp4',
        title: 'Get Started With Dataset Marketplace',
        subtitle: 'A quick guide to get familiar with our Dataset Marketplace',
        u_wide: 1,
        embeded: 'https://www.youtube.com/embed/GbQGM9fAVqs',
    },
    WEB_SCRAPER_IDE: {
        type: 'dca',
        src: '/static/web_scraper_ide.mp4',
        title: <Translation>
          {t=>t('learn_more.web_scraper_ide.video_title')}
        </Translation>,
        subtitle: <Translation>
          {t=>t('learn_more.web_scraper_ide.video_description')}
        </Translation>,
        u_wide: 1,
        embeded: 'https://www.youtube.com/embed/Ve04_6gDKvU',
    },
    BRIGHT_INSIGHTS: {
        type: 'dca',
        src: '/static/bright_insights.mp4',
        title: 'Get Started With Bright Insights',
        subtitle: 'Bright Insights, the eCommerce analytics '+
            'for brands and retailers with actionable insights on the '+
            'market, and competition',
        u_wide: 1,
    },
    SERP: {
        src: '/static/serp.mp4',
        title: 'Get Started With SERP API',
        subtitle: 'A quick guide to get familiar with our SERP API',
        u_wide: 1,
        embeded: 'https://www.youtube.com/embed/NZkO1cTP2c4',
    },
    ISP: {
        src: '/static/isp.mp4',
        title: 'Get Started With ISP proxies',
        subtitle: 'A quick guide to get familiar with our ISP IPs',
        u_wide: 1,
        embeded: 'https://www.youtube.com/embed/7E_rO7wXK2g',
    },
    RESIDENTIAL: {
        src: '/static/residential.mp4',
        title: 'Get Started With Residential proxies',
        subtitle: 'A quick guide to get familiar with our Residential IPs',
        u_wide: 1,
        embeded: 'https://www.youtube.com/embed/gm_co579dMo',
    },
    RESIDENTIAL_AND_MOBILE: {
        src: '/static/residential.mp4',
        title: 'Get Started With Residential & Mobile proxies',
        subtitle: 'A quick guide to get familiar with our Residential IPs',
        u_wide: 1,
    },
    DATA_CENTER: {
        src: '/static/data_center.mp4',
        title: 'Get Started With Datacenter proxies',
        subtitle: 'A quick guide to get familiar with our Datacenter IPs',
        u_wide: 1,
        embeded: 'https://www.youtube.com/embed/Rbqsn-Kjt_Q',
    },
    MOBILE: {
        src: '/static/mobile.mp4',
        title: 'Get Started With Mobile proxies',
        subtitle: 'A quick guide to get familiar with our Mobile IPs',
        u_wide: 1,
        embeded: 'https://www.youtube.com/embed/AuZ-ncnYhhk',
    },
    WEB_UNLOCKER: {
        src: '/static/web_unlocker.mp4',
        title: 'Get Started With Web Unlocker API',
        subtitle: 'A quick guide to get familiar with our Web Unlocker API',
        u_wide: 1,
        embeded: 'https://www.youtube.com/embed/DtYHBedquNc',
    },
    SCRAPING_BROWSER: {
        src: '/static/scraping_browser.mp4',
        title: 'Get Started With Browser API',
        subtitle: 'A quick guide to get familiar with our Browser API',
        u_wide: 1,
        embeded: 'https://www.youtube.com/embed/Qzo8JKYurek',
    },
    WELCOME_TO_KYC: {
        src: '/static/welcome_kyc.mp4',
        title: 'Why we use Know Your Customer process',
        subtitle: 'A quick video to get familier with our KYC process',
        u_wide: 1,
    },
};
E.TOOLTIP_TEXTS = {
    PREMIUM_DOMAINS: 'Access websites that are more challenging to unblock '+
        'than others and require additional resources, Click to learn more',
    TARGET_DOMAINS: '',
    GEOLOCATION_TARGETING: '',
    DEFAULT_COUNTRY: 'Select default countries or leave empty to get a ' +
        'random country, click here to learn more',
    SERP_ASYNC_REQS: '',
    UNLIM_BW_PKG: '',
    UPTIME: '',
    BANDWIDTH: '',
    DC_ISP_IP_TYPE: '',
    RESI_MOBILE_IP_TYPE: '',
    RESI_MOBILE_NUM_DOMAINS: `Every request through this zone targeting the `+
        `domains in the list is sent via your dedicated proxies. Requests `+
        `to other domains are sent thru our Super-Proxy servers, hosted and `+
        `owned by Bright Data`,
    CACHE_PROXY: '',
    LONG_SESSION_PEERS: '',
    AUTO_UB: '',
};
E.TOOLTIP_LINKS = {
    WEB_UNLOCKER_THROTTHLE: '',
    NUMBER_OF_IP: '',
    SOCKS5_PROXY: '',
    FORCE_SSL_PROXY: '',
    SMART_RESI_CERTIFICATE: '',
    TARGET_HOST_IP: '',
    ALLOWED_IPS: '',
    AUTO_UB: '',
};
return E;
});
